import React from 'react';
import { Hero } from './components/Hero';
import { Overview } from './components/Overview';
import { InvestmentDescription } from './components/InvestmentDescription';
import { Gallery } from './components/Gallery';
import { Reconversion } from './components/Reconversion';
import { FinancialAnalysis } from './components/FinancialAnalysis';
import { InvestmentCalculator } from './components/InvestmentCalculator';
import { Location } from './components/Location';
import { Motivation } from './components/Motivation';
import { TechnicalData } from './components/TechnicalData';
import { TechnicalPlans } from './components/TechnicalPlans';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Overview data-id="element-2" />
      <InvestmentDescription data-id="element-3" />
      <Gallery data-id="element-4" />
      <Reconversion data-id="element-5" />
      <FinancialAnalysis data-id="element-6" />
      <InvestmentCalculator data-id="element-7" />
      <Location data-id="element-8" />
      <Motivation data-id="element-9" />
      <TechnicalData data-id="element-10" />
      <TechnicalPlans data-id="element-11" />
      <About data-id="element-12" />
      <Contact data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}